export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
  summary: string;
  cover: string;
  content: string[];
  relatedIds: string[];
}

export const newsCategories: string[] = ['全部资讯', '电影新闻', '电视剧动态', '行业资讯'];

export const newsList: NewsItem[] = [
  {
    id: 'n1',
    title: '《长安十二辰》定档春季，国风美学预告引发热议',
    category: '电视剧动态',
    date: '2025-03-12',
    author: '粉色水蜜桃编辑部',
    summary:
      '备受期待的古装悬疑剧《长安十二辰》正式宣布定档，首支预告以一镜到底的夜景长镜头引爆讨论，网友称「每一帧都能截图当壁纸」。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20ancient%20chinese%20lantern%20lit%20street%20at%20night%20with%20warm%20amber%20glow%20and%20silk%20banners%20grand%20historical%20production%20film%20grain%20no%20text%20high%20detail&width=800&height=500&seq=news-01&orientation=landscape',
    content: [
      '备受期待的古装悬疑剧《长安十二辰》今日正式宣布定档春季，官方同步释出首支预告片。预告以一镜到底的夜景长镜头开场，还原了盛唐长街的灯火与市井烟火，短短两分钟内便完成了一次完整的时空穿越。',
      '制作团队在采访中透露，剧中大量场景采用实景搭建与实拍结合的方式完成，仅主街场景便耗时数月搭建，力求让观众在视觉上真正「走进去」。服装与道具也参考了多份史料进行还原，细节之处可见用心。',
      '预告发布后迅速登上多个平台的热门话题，不少观众表示「每一帧都能截图当壁纸」。也有原著粉关注剧情改编的方向，期待主创能在保留核心悬念的同时，带来新的叙事节奏。',
      '《长安十二辰》共 40 集，将围绕一桩发生在十二个时辰内的疑案展开。更多物料与开播信息，本站将持续跟进报道。',
    ],
    relatedIds: ['n4', 'n7', 'n2'],
  },
  {
    id: 'n2',
    title: '《雾都黎明》口碑持续走高，悬疑叙事被赞「不糊弄观众」',
    category: '电视剧动态',
    date: '2025-02-28',
    author: '剧集观察',
    summary:
      '刑侦剧《雾都黎明》开播以来评分稳步上升，观众普遍认可其扎实的推理逻辑与克制的情绪表达，「反套路但不刻意」成为高频评论。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20foggy%20old%20city%20street%20at%20dawn%20with%20muted%20crimson%20light%20and%20detective%20silhouette%20moody%20atmosphere%20film%20grain%20no%20text%20high%20detail&width=800&height=500&seq=news-02&orientation=landscape',
    content: [
      '刑侦题材剧集《雾都黎明》播出过半，口碑持续走高。与近年部分强调强反转的作品不同，该剧把力气花在了线索的铺垫与人物动机的打磨上，被观众评价为「不糊弄观众」。',
      '剧中两位主角的组合成为讨论焦点：老刑警的沉稳与年轻搭档的锋芒形成鲜明对照，两人的磨合过程既推动案情，也完成了一次关于信念传承的书写。',
      '有评论指出，该剧最难得的是对「慢」的坚持——不急于一集一个爆点，而是让真相在层层递进中自然浮现。这种叙事耐心在当下显得尤为珍贵。',
    ],
    relatedIds: ['n1', 'n6', 'n8'],
  },
  {
    id: 'n3',
    title: '行业观察：流媒体时代，长剧集正在「变短」',
    category: '行业资讯',
    date: '2025-02-15',
    author: '影视产业组',
    summary:
      '近期多部高热剧集将篇幅压缩至十余集，节奏更紧凑的创作趋势正在改变观众的追剧习惯，也推动制作方重新思考「一集该讲多少事」。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20film%20industry%20concept%20image%20of%20editing%20timeline%20and%20warm%20studio%20lights%20minimal%20desk%20composition%20soft%20peach%20tones%20editorial%20photography%20no%20text%20high%20detail&width=800&height=500&seq=news-03&orientation=landscape',
    content: [
      '近两年，越来越多高热剧集开始主动「瘦身」，将总篇幅控制在十余集以内。篇幅缩短带来的并不只是观看时长的变化，更是叙事密度与信息节奏的整体重构。',
      '多位创作者表示，短篇幅意味着每一集都必须承担明确的推进功能，注水桥段的空间被大幅压缩。对观众而言，这意味着更少的等待与更密集的有效信息；对制作方而言，则考验着前期剧本的打磨功力。',
      '也有从业者提醒，篇幅本身不是优劣的评判标准。真正重要的是内容与形式的匹配——故事需要一个足够立体的世界时，充分的展开依然必要。',
      '可以预见的是，围绕「讲好一个故事需要多长」的讨论，仍将持续影响未来的创作选择。',
    ],
    relatedIds: ['n7', 'n1', 'n5'],
  },
  {
    id: 'n4',
    title: '《星轨之外》发布幕后特辑，实拍与视效如何融合',
    category: '电影新闻',
    date: '2025-01-30',
    author: '电影前线',
    summary:
      '科幻大片《星轨之外》公开幕后制作特辑，主创详解如何在有限预算下，用实景搭建与后期视效的结合营造可信的深空质感。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20of%20a%20sci%20fi%20film%20set%20with%20astronaut%20prop%20and%20warm%20studio%20lighting%20deep%20orange%20accents%20film%20grain%20no%20text%20high%20detail&width=800&height=500&seq=news-04&orientation=landscape',
    content: [
      '科幻电影《星轨之外》近日公开幕后制作特辑，团队分享了影片中深空场景的诞生过程。为了让演员的表演更有真实感，剧组搭建了大量可实际进入的舱体布景，而非完全依赖绿幕。',
      '视效总监表示，团队刻意保留了部分手持镜头与真实光源，让画面在宏大之余仍保留呼吸感。「我们不追求绝对干净，而是希望观众相信这是有人待过的地方。」',
      '特辑中还可以看到宇航服的制作细节：为了让服装在镜头下显得自然，团队反复调整了重量与关节结构，使演员能够完成更丰富的动作。',
    ],
    relatedIds: ['n6', 'n2', 'n8'],
  },
  {
    id: 'n5',
    title: '治愈系剧集为何持续走红？慢节奏里的情绪刚需',
    category: '行业资讯',
    date: '2025-01-18',
    author: '剧集观察',
    summary:
      '从《山海食堂》到《首尔夜行》，节奏舒缓、情感细腻的治愈系作品不断收获好评，背后是观众对「被安慰」的普遍需求。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20warm%20evening%20kitchen%20scene%20with%20steaming%20food%20and%20soft%20lantern%20light%20rustic%20wooden%20table%20comforting%20atmosphere%20editorial%20photography%20no%20text%20high%20detail&width=800&height=500&seq=news-05&orientation=landscape',
    content: [
      '没有强冲突、没有密集反转，却能让人一集接一集地看下去——近年治愈系剧集正悄然占据观众片单的重要位置。',
      '分析认为，这类作品的价值在于提供情绪上的缓冲。在快节奏的日常之外，观众需要一个可以放下戒备的空间，看别人认真做一顿饭、认真地生活。',
      '当然，治愈并不等于平淡。成功的作品往往在温和的外壳下藏着真实的困境，只是它们选择以更温柔的方式去回应，而不是放大焦虑。',
    ],
    relatedIds: ['n3', 'n1', 'n7'],
  },
  {
    id: 'n6',
    title: '《伦敦迷雾》第二季确认开发，原班主创回归',
    category: '电视剧动态',
    date: '2024-12-22',
    author: '国际剧集组',
    summary:
      '英剧《伦敦迷雾》正式确认开发第二季，主创团队与原班主演将悉数回归，新一季的故事将把线索延伸到城市之外。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20foggy%20victorian%20london%20street%20with%20gas%20lamps%20muted%20amber%20tones%20moody%20detective%20atmosphere%20film%20grain%20no%20text%20high%20detail&width=800&height=500&seq=news-06&orientation=landscape',
    content: [
      '凭借扎实推理与浓郁氛围收获口碑的英剧《伦敦迷雾》正式确认开发第二季。官方表示，主创团队与主要演员都将回归，延续第一季的世界观。',
      '制片人在采访中透露，新一季会把调查的触角从熟悉的街区延伸到更远的地方，「城市之外还有更大的谜题在等着」。',
      '第一季结尾留下的开放式悬念将在新季得到回应，同时也会有新的角色加入，为故事带来不同的视角。',
    ],
    relatedIds: ['n4', 'n2', 'n3'],
  },
  {
    id: 'n7',
    title: '从「看完就忘」到「反复回看」，口碑长尾正在形成',
    category: '行业资讯',
    date: '2024-12-05',
    author: '影视产业组',
    summary:
      '越来越多的作品不再只依赖开播热度，而是凭借扎实内容在播出后持续被讨论、被回看，形成更长的价值周期。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20modern%20home%20living%20room%20with%20a%20glowing%20screen%20and%20cozy%20peach%20tones%20quiet%20evening%20mood%20editorial%20photography%20no%20text%20high%20detail&width=800&height=500&seq=news-07&orientation=landscape',
    content: [
      '过去，一部剧的价值往往在开播期就被快速消耗；如今，越来越多作品在播出后仍被反复讨论和回看，口碑的「长尾」正在变得可观。',
      '这种变化一方面来自观众审美的成熟——人们更愿意为经得起推敲的内容多花时间；另一方面也来自分享与讨论的便利，好的细节会被反复提及、重新发现。',
      '对创作者而言，这意味着「一次性爆点」的吸引力在下降，而真正扎实的叙事与人物塑造，才是让作品被长久记住的关键。',
    ],
    relatedIds: ['n3', 'n5', 'n1'],
  },
  {
    id: 'n8',
    title: '《追风者》幕后：一场赛车戏是如何拍出来的',
    category: '电影新闻',
    date: '2024-11-20',
    author: '电影前线',
    summary:
      '动作电影《追风者》公开赛车戏拍摄花絮，专业车手团队与摄影组的配合，让高速镜头在安全前提下依然保持真实质感。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20racing%20film%20scene%20of%20a%20sports%20car%20on%20a%20coastal%20road%20at%20sunset%20with%20warm%20orange%20sky%20and%20motion%20blur%20film%20grain%20no%20text%20high%20detail&width=800&height=500&seq=news-08&orientation=landscape',
    content: [
      '电影《追风者》近日释出赛车戏的拍摄花絮。为了让观众身临其境，剧组请来了专业车手团队参与驾驶，并设计了多套摄影机位方案。',
      '导演在受访时表示，最难的并不是把车开快，而是让镜头「跟得上」。「速度感来自节奏，而不是单纯的快。」为此，团队大量使用了贴地机位与车内视角的切换。',
      '安全同样是重点。所有高速镜头都在封闭路段完成，并配备完整的应急方案。花絮中可以看到，同一条赛道镜头往往需要反复拍摄数十次才能达到理想效果。',
    ],
    relatedIds: ['n4', 'n6', 'n2'],
  },
];